import type { App } from 'vue';
import pinia from '@/store';

/**
 * Pinia 插件
 * @param app Vue应用实例
 */
export function setupPinia(app: App) {
  app.use(pinia);
}

// 导出 pinia 实例（兼容旧代码）
export { pinia };
